import React from 'react';
import './Safety.css';

const Safety = () => {
  const safetyTips = [
    {
      id: 1,
      icon: '🛡️',
      title: 'Photo Verification',
      description: 'We use facial recognition technology to verify that our members are who they say they are.'
    },
    {
      id: 2,
      icon: '🔒',
      title: 'Private Messaging',
      description: 'Your conversations stay private. We never share your messages with third parties.'
    },
    {
      id: 3,
      icon: '🚫',
      title: 'Block & Report',
      description: 'Easily block and report anyone who makes you uncomfortable. We take safety seriously.'
    },
    {
      id: 4,
      icon: '📍',
      title: 'Location Control',
      description: 'You control who sees your location. Share only what you\'re comfortable with.'
    }
  ];

  return (
    <section className="safety">
      <div className="container">
        <div className="safety-content">
          <div className="safety-header">
            <span className="safety-badge">Safety First</span>
            <h2 className="safety-title">Your Safety Matters</h2>
            <p className="safety-description">
              At Tinder, your safety is our top priority. We've built features and policies 
              to help you have a safe and enjoyable experience. Here's how we protect you.
            </p>
          </div>

          <div className="safety-grid">
            {safetyTips.map((tip, index) => (
              <div 
                key={tip.id} 
                className="safety-card"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <span className="safety-icon">{tip.icon}</span>
                <h3 className="safety-card-title">{tip.title}</h3>
                <p className="safety-card-description">{tip.description}</p>
              </div>
            ))}
          </div>

          <div className="safety-cta">
            <a href="#" className="safety-link">Learn more about safety</a>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M4 10h12M12 4l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Safety;
